import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@gasbuddy/react-components';
import BadgeImage from '../BadgeImage';
import { noop } from '../../../lib/utils';

export default function BadgeWithModal({
  imageUrl,
  title,
  onClick,
  onModalOpen,
  children,
}) {
  return (
    <Modal
      content={children}
      size="sm"
      onOpen={onModalOpen}
    >
      {({ open }) => (
        <BadgeImage
          src={imageUrl}
          alt={title}
          clickable
          onClick={(e) => {
            onClick(e);
            open(e);
          }}
          title={title}
        />
      )}
    </Modal>
  );
}

BadgeWithModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onModalOpen: PropTypes.func,
  children: PropTypes.node,
};

BadgeWithModal.defaultProps = {
  onClick: noop,
  onModalOpen: undefined,
  children: [],
};
